import React from 'react'
import PropTypes from 'prop-types'
import { IconSLI60Wrapper } from './IconSLI60Wrapper'

export const Icon60Arrow2Left = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLI60Wrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 48 27.91'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M47.000,14.959 L3.547,14.959 L15.681,26.186 C16.085,26.560 16.108,27.191 15.733,27.594 C15.536,27.805 15.268,27.913 15.000,27.913 C14.756,27.913 14.512,27.825 14.319,27.646 L0.319,14.693 C0.315,14.689 0.313,14.683 0.309,14.678 C0.236,14.609 0.184,14.523 0.135,14.434 C0.120,14.406 0.095,14.385 0.082,14.356 C0.030,14.235 0.000,14.103 0.000,13.963 C0.000,13.823 0.030,13.691 0.082,13.570 C0.095,13.540 0.121,13.518 0.136,13.490 C0.185,13.403 0.236,13.317 0.308,13.248 C0.313,13.244 0.314,13.237 0.319,13.232 L14.319,0.280 C14.725,-0.095 15.356,-0.072 15.733,0.332 C16.108,0.735 16.085,1.365 15.681,1.740 L3.547,12.966 L47.000,12.966 C47.552,12.966 48.000,13.413 48.000,13.963 C48.000,14.513 47.552,14.959 47.000,14.959 Z'
        />
      </svg>
    </IconSLI60Wrapper>
  )
}

Icon60Arrow2Left.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
